module.exports = __webpack_public_path__ + "static/favicon-992692f988e3130441297d9d4460cacd.ico";